<template>
  <div class="filter-tree" style="text-align:left;">
    <Input readonly v-model="data">
    <Button slot="append" icon="ios-search" @click="open"></Button>
    </Input>
    <Modal class="tree-modal" v-model="modal" :closable="false" @on-ok="ok" @on-cancel="cancel">
      <!-- 筛选 -->
      <Input prefix="ios-search" v-model.trim="searchVal" placeholder="请输入名称" style="width: auto" @on-change="inputChange" @on-enter="enterEvent" />
      <div class="content">
        <Tree ref="tree" v-if="nodes.length" :data="dataNodes" @on-select-change="selectChange"></Tree>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'DsTree',
  props: {
    nodes: {
      type: Array,
      default: () => {
        return []
      }
    },
    data: {
      type: String
    }
  },
  data () {
    return {
      modal: false,
      searchVal: '',
      obj: {},
      dataNodes: [],
      isEnter: false,
      timeout: null
    }
  },
  watch: {
    nodes: {
      handler (v) {
        this.dataNodes = v.slice()
      },
      deep: true
    },
    modal (n) {
      clearTimeout(this.timeout)
    }
  },
  mounted () {
  },
  methods: {
    open () {
      this.modal = true
      this.searchVal = ''
      this.dataNodes = JSON.parse(JSON.stringify(this.nodes))
    },
    enterEvent () {
      if (this.timeout) clearTimeout(this.timeout)
      this.search()
    },
    search () {
      this.initScrollTop()
      this.modal = true
      this.dataNodes = JSON.parse(JSON.stringify(this.nodes))
      if (!this.searchVal) return
      let node = this.findData(this.searchVal)
      if (!node.length) {
        this.$Message.info('没有查到数据！')
        return
      }
      let arr = []
      for (let i = 0; i < node.length; i++) {
        arr.push(node[i].level)
      }
      function forEach (data) {
        for (let i = 0; i < data.length; i++) {
          if (node.filter(x => x.level.includes(data[i].level)).length) {
            data[i].expand = true
          }
          if (Array.isArray(data[i].children) && data[i].children.length > 0) {
            forEach(data[i].children)
          }
        }
      }
      forEach(this.dataNodes)
    },
    findData (v) {
      let node = []
      function forEach (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].title.includes(v)) {
            node.push(data[i])
          } else {
            if (Array.isArray(data[i].children) && data[i].children.length > 0) {
              forEach(data[i].children)
            }
          }
        }
      }
      forEach(this.dataNodes)
      return node
    },
    ok () {
      this.initScrollTop()
      this.$emit('getTreeResult', this.obj)
    },
    initScrollTop () {
      let c = document.getElementsByClassName('content')[0]
      c.scrollTop = 0
    },
    cancel () {
      this.modal = false
      this.initScrollTop()
    },
    selectChange (v, d) {
      this.obj = { id: d.id, title: d.title, full_code: d.level }
    },
    inputChange (v) {
      this.debounce(this.search, 2000)
    },
    debounce (func, wait) {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        func()
      }, wait)
    }
  }
}
</script>
<style lang="stylus">
.tree-modal {
  .content {
    max-height: 50vh !important;
    overflow: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dstree/DsTree.vue